import { Link, useLocation } from 'react-router-dom'
import { useInvoiceReadyCount } from '../api/queries'
import { useAuth } from '../auth/AuthProvider'

/**
 * Antal sager, der er klar til faktura (beslutning 147) - 0 for alle andre end kontoret
 * (Kontor og administratorer). Der spørges slet ikke, hvis man ikke er på kontoret.
 */
export function useInvoiceReadyCountForOffice(): number {
  const { isIntranetAdmin } = useAuth()
  const { data } = useInvoiceReadyCount(isIntranetAdmin)
  return isIntranetAdmin ? data?.count ?? 0 : 0
}

/**
 * Stribe øverst på alle sider for kontoret, når der er sager klar til faktura - samme slags som
 * kvitteringernes (Simon 2026-10-29: "lige som med kvitteringer"). Den forsvinder, når sagerne er
 * noteret som faktureret, og står ikke på selve siden "Til fakturering".
 */
export function InvoiceReadyBanner() {
  const count = useInvoiceReadyCountForOffice()
  const location = useLocation()

  if (count === 0 || location.pathname === '/invoicing') return null

  return (
    <div className="banner banner--receipts">
      <span aria-hidden style={{ fontSize: 22 }}>💰</span>
      <span style={{ flex: 1 }}>
        <b>{count === 1 ? '1 sag er klar' : `${count} sager er klar`} til faktura</b>
      </span>
      <Link className="btn btn--primary btn--sm" to="/invoicing">
        Se sagerne
      </Link>
    </div>
  )
}
